export enum DatePickerDateFormatTypes {
  european = 'dd.mm.yyyy',
  american = 'mm.dd.yyyy',
}
